import { Component } from '@angular/core';

@Component({
  selector: 'app-soilguard-footer',
  templateUrl: './soilguard-footer.component.html',
  styleUrls: ['./soilguard-footer.component.scss']
})
export class SoilguardFooterComponent {
  date = new Date().getFullYear();
}
